type IconProps = {
  className: string
}

export const Icon = ({ className }: IconProps) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 14C9 13.4477 9.44772 13 10 13C10.5523 13 11 13.4477 11 14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14Z"
      fill="#FF6A00"
    />
    <path
      d="M9 7.5C9 6.94772 9.44772 6.5 10 6.5C10.5523 6.5 11 6.94772 11 7.5V11C11 11.5523 10.5523 12 10 12C9.44772 12 9 11.5523 9 11V7.5Z"
      fill="#FF6A00"
    />
    <path
      d="M8.36056 3.89915L9.14834 4.38394L8.36056 3.89915L2.15012 13.9911C1.36085 15.2737 2.2836 16.925 3.78956 16.925H16.2104C17.7164 16.925 18.6392 15.2737 17.8499 13.9911L11.6394 3.89915C10.8878 2.67767 9.11224 2.67767 8.36056 3.89915Z"
      stroke="#FF6A00"
      strokeWidth="1.85"
    />
  </svg>
)
